"use strict";

var _defineProperty = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$txTypeMap;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module index
 */

var axios_1 = __importDefault(require("axios"));

var marshall_1 = require("@waves/marshall");

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

var transactions_1 = require("./transactions");

var issue_1 = require("./transactions/issue");

var transfer_1 = require("./transactions/transfer");

var reissue_1 = require("./transactions/reissue");

var burn_1 = require("./transactions/burn");

var lease_1 = require("./transactions/lease");

var cancel_lease_1 = require("./transactions/cancel-lease");

var data_1 = require("./transactions/data");

var mass_transfer_1 = require("./transactions/mass-transfer");

var alias_1 = require("./transactions/alias");

var set_script_1 = require("./transactions/set-script");

var generic_1 = require("./generic");

var set_asset_script_1 = require("./transactions/set-asset-script");

var exchange_1 = require("./transactions/exchange");

var sponsorship_1 = require("./transactions/sponsorship");

var invoke_script_1 = require("./transactions/invoke-script");

var custom_data_1 = require("./requests/custom-data");

var auth_1 = require("./requests/auth");

var wavesAuth_1 = require("./requests/wavesAuth");

exports.txTypeMap = (_exports$txTypeMap = {}, _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.ISSUE, {
  sign: function sign(x, seed) {
    return issue_1.issue(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.TRANSFER, {
  sign: function sign(x, seed) {
    return transfer_1.transfer(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.REISSUE, {
  sign: function sign(x, seed) {
    return reissue_1.reissue(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.BURN, {
  sign: function sign(x, seed) {
    return burn_1.burn(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.LEASE, {
  sign: function sign(x, seed) {
    return lease_1.lease(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.CANCEL_LEASE, {
  sign: function sign(x, seed) {
    return cancel_lease_1.cancelLease(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.ALIAS, {
  sign: function sign(x, seed) {
    return alias_1.alias(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.MASS_TRANSFER, {
  sign: function sign(x, seed) {
    return mass_transfer_1.massTransfer(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.DATA, {
  sign: function sign(x, seed) {
    return data_1.data(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.SET_SCRIPT, {
  sign: function sign(x, seed) {
    return set_script_1.setScript(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.SET_ASSET_SCRIPT, {
  sign: function sign(x, seed) {
    return set_asset_script_1.setAssetScript(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.SPONSORSHIP, {
  sign: function sign(x, seed) {
    return sponsorship_1.sponsorship(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.EXCHANGE, {
  sign: function sign(x, seed) {
    return exchange_1.exchange(x, seed);
  }
}), _defineProperty(_exports$txTypeMap, transactions_1.TRANSACTION_TYPE.INVOKE_SCRIPT, {
  sign: function sign(x, seed) {
    return invoke_script_1.invokeScript(x, seed);
  }
}), _exports$txTypeMap);
/**
 * Signs arbitrary transaction. Can also create signed transaction if provided params have type field
 * @param tx
 * @param seed
 */

function signTx(tx, seed) {
  if (!exports.txTypeMap[tx.type]) throw new Error("Unknown tx type: ".concat(tx.type));
  return exports.txTypeMap[tx.type].sign(tx, seed);
}

exports.signTx = signTx;
/**
 * Converts transaction or order object to Uint8Array
 * @param obj transaction or order
 */

function serialize(obj) {
  if (generic_1.isOrder(obj)) return marshall_1.binary.serializeOrder(obj);
  return marshall_1.binary.serializeTx(obj);
}

exports.serialize = serialize;
/**
 * Verifies signature of transaction or order
 * @param obj
 * @param proofN - proof index. Takes first proof by default
 * @param publicKey - takes senderPublicKey by default
 */

function verify(obj) {
  var proofN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var publicKey = arguments.length > 2 ? arguments[2] : undefined;
  publicKey = publicKey || obj.senderPublicKey;
  var bytes = serialize(obj);
  var signature = obj.version == null ? obj.signature : obj.proofs[proofN];
  return ts_lib_crypto_1.verifySignature(publicKey, bytes, signature);
}

exports.verify = verify;

function verifyCustomData(data) {
  var bytes = custom_data_1.serializeCustomData(data);
  return ts_lib_crypto_1.verifySignature(data.publicKey, bytes, data.signature);
}

exports.verifyCustomData = verifyCustomData;

function verifyAuthData(authData, params, chainId) {
  chainId = chainId || 'W';
  var bytes = auth_1.serializeAuthData(params);
  var myAddress = ts_lib_crypto_1.address({
    publicKey: authData.publicKey
  }, chainId);
  return myAddress === authData.address && ts_lib_crypto_1.verifySignature(authData.publicKey, bytes, authData.signature);
}

exports.verifyAuthData = verifyAuthData;

function verifyWavesAuthData(authData, params, chainId) {
  chainId = chainId || 'W';
  var bytes = wavesAuth_1.serializeWavesAuthData(params);
  var myAddress = ts_lib_crypto_1.address({
    publicKey: authData.publicKey
  }, chainId);
  return myAddress === authData.address && ts_lib_crypto_1.verifySignature(authData.publicKey, bytes, authData.signature);
}

exports.verifyWavesAuthData = verifyWavesAuthData;

function submitOrder(ord, opts) {
  var endpoint, matcherUrl;

  if (typeof opts === 'string') {
    matcherUrl = opts;
    endpoint = 'matcher/orderbook';
  } else {
    matcherUrl = opts.matcherUrl;
    endpoint = opts.market ? 'matcher/orderbook/market' : 'matcher/orderbook';
  }

  return axios_1.default.post(endpoint, marshall_1.json.stringifyOrder(ord), {
    baseURL: matcherUrl,
    headers: {
      'content-type': 'application/json'
    }
  }).then(function (x) {
    return x.data;
  }).catch(function (e) {
    return Promise.reject(e.response && e.response.status === 400 ? new Error(e.response.data.message) : e);
  });
}

exports.submitOrder = submitOrder;
/**
 * Sends cancel order command to matcher. Since matcher api requires amountAsset and priceAsset in request url,
 * this function requires them as params
 * @param co - signed cancelOrder object
 * @param amountAsset - amount asset of the order to be canceled
 * @param priceAsset - price asset of the order to be canceled
 * @param matcherUrl - matcher address to send order cancel to. E.g. https://matcher.waves.exchange/
 */

function cancelSubmittedOrder(co, amountAsset, priceAsset, matcherUrl) {
  return axios_1.default.post("matcher/orderbook/".concat(amountAsset || 'WAVES', "/").concat(priceAsset || 'WAVES', "/cancel"), JSON.stringify(co), {
    baseURL: matcherUrl,
    headers: {
      'content-type': 'application/json'
    }
  }).then(function (x) {
    return x.data;
  }).catch(function (e) {
    return Promise.reject(e.response && e.response.status === 400 ? new Error(e.response.data.message) : e);
  });
}

exports.cancelSubmittedOrder = cancelSubmittedOrder;